import React, { Component } from "react";
import Button from "react-bootstrap-button-loader";
import { connect } from "react-redux";
import _ from "lodash";
import { Field, reduxForm, reset } from "redux-form";
import { Modal } from "react-bootstrap";
// import moment from 'moment';
import moment from "moment-timezone";
import StarRatings from "react-star-ratings";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { showError, showSuccess } from "ReduxErrorBar";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import {
  COMMON_FAIL_MESSAGE,
  validateEmail,
  validateSpecialChar,
} from "Constants";
import LocaleStrings from "Languages";
import {
  openAddReviewer,
  sendLoginCredentials,
  createReviewer,
  validateEmailForReviewer,
} from "ProposalAction";

class AddReviewer extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.state = { loading: false, selectedTab: 1 };
  }

  componentDidMount() {}

  closeModal() {
    this.props.openAddReviewer(false, "");
  }

  onSubmitForm(data) {
    // console.log("form submit data", data);
    // debugger;
    var { addReviewerModal } = this.props;

    var array = [];
    var values = {};

    var mainFields = ["email", "firstname", "lastname", "userpassword"];

    _.map(mainFields, (main) => {
      if (data.hasOwnProperty(main)) {
        values[main] = data[main];
      }
    });

    values.username = data.firstname + " " + data.lastname;
    values.userpassword = data.userpassword ? data.userpassword : "";

    this.setState({ loading: true });

    this.props.validateEmailForReviewer(
      this.props.session,
      values,
      (validationresponse) => {
        if (validationresponse.success === 2) {
          this.props.showError(validationresponse.message);
          this.setState({ loading: false });
        } else if (validationresponse.success == 1) {
          this.props.createReviewer(this.props.session, values, (response) => {
            if (response.success === 0) {
              this.setState({ loading: false });
              this.props.showError(COMMON_FAIL_MESSAGE);
            } else {
              let mailData = {};
              mailData.password = values.userpassword;
              let appuserid = response.appuserid;
              mailData.appuserid = appuserid;
              this.props.sendLoginCredentials(
                this.props.session,
                mailData,
                (feedback) => {
                  if (feedback.success === 0) {
                    this.setState({ loading: false });
                    this.props.showError(COMMON_FAIL_MESSAGE);
                  } else {
                    this.props.reset();
                    this.setState({ loading: false });
                    this.props.showSuccess(
                      LocaleStrings.proposal_reviewer_add_succesfully
                    );
                    this.props.finishOperationsCallback();
                    this.closeModal();
                  }
                }
              );
            }
          });
        } else {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  }

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      settingData,
      addReviewerModal,
    } = this.props;
    //console.log('addReviewerModal',addReviewerModal);
    var edit = false;

    return (
      <div>
        <Modal
          className="modal-container"
          show={addReviewerModal.showModal === true ? true : false}
          onHide={this.closeModal}
          animation={true}
        >
          <Modal.Header>
            <div className="import-modal-title">{`${LocaleStrings.dashboard_button_add_reviewer}`}</div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.closeModal()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <form
            onSubmit={handleSubmit(this.onSubmitForm)}
            encType="multipart/form-data"
          >
            <Modal.Body>
              <div>
                <AddUserForm {...this.props} />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                bsStyle=""
                className="btn btn-custom-white"
                onClick={this.closeModal}
              >
                {LocaleStrings.button_close}
              </Button>
              <Button
                className="btn btn-custom-blue ml-10"
                bsStyle=""
                loading={this.state.loading}
                disabled={pristine || invalid || submitting}
                type="submit"
              >
                {LocaleStrings.button_save}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    addReviewerModal: state.addReviewerModal,
    eventDetails: state.userEventDetails,
    settingData: state.SettingData.resource,
  };
}

function validate(values, props) {
  var { userCategoryList } = props;
  var errors = {};
  // var username = values['username'];
  var firstname = values["firstname"];
  var lastname = values["lastname"];
  var email = values["email"];
  var category = values["usercategory"];
  var userPassword = values["userpassword"];

  // if (!username || username.trim() === '') {
  //   errors['username'] = LocaleStrings.user_validation_required;
  // } else if (!(/^[a-zA-Z0-9- ]*$/.test(username))) {
  //   errors['username'] = LocaleStrings.user_validation_name_cannot_contain_special_char;
  // }
  if (!firstname || firstname.trim() === "") {
    errors["firstname"] = LocaleStrings.user_validation_required;
  } else if (validateSpecialChar(firstname)) {
    errors["firstname"] =
      LocaleStrings.user_validation_name_cannot_contain_special_char;
  }
  if (!lastname || lastname.trim() === "") {
    errors["lastname"] = LocaleStrings.user_validation_required;
  } else if (validateSpecialChar(lastname)) {
    errors["lastname"] =
      LocaleStrings.user_validation_name_cannot_contain_special_char;
  }

  if (!email || email.trim() === "") {
    errors["email"] = LocaleStrings.user_validation_required;
  }
  if (email && !validateEmail(email)) {
    errors["email"] = LocaleStrings.user_validation_invalid_email;
  }

  if (!userPassword || userPassword.trim() === "") {
    errors["userpassword"] = LocaleStrings.user_validation_required;
  }
  if (userPassword && userPassword.length < 6) {
    errors["userpassword"] = LocaleStrings.user_password_length_validation;
  }
  return errors;
}

export default connect(mapStateToProps, {
  openAddReviewer,
  showError,
  showSuccess,
  validateEmailForReviewer,
  sendLoginCredentials,
  createReviewer,
})(
  reduxForm({
    validate,
    form: "DashboardAddUserForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(AddReviewer)
);

class AddUserForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { showPasswordField: false };
  }

  componentDidMount() {
    var { editMode, initialValues, session, source } = this.props;
  }

  renderCustomSelect(field) {
    var { opts, input, placeholder } = field;
    var defaultVal = input.value;
    var values = [];
    var selected = [];
    var defaultLabel = { placeholderButtonLabel: placeholder, value: [] };

    if (defaultVal && defaultVal != "") {
      if (Array.isArray(defaultVal)) {
        values = defaultVal;
      } else {
        values = defaultVal.toString().split(",");
      }

      values.forEach((item) => {
        var added = _.filter(opts, (obj) => {
          return obj.value == item;
        });
        selected.push(added[0]);
      });

      defaultLabel.value = selected;
    }

    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    return (
      <div className={divClassName}>
        <label className="control-label-top col-sm-12">
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>
        <div className="col-md-12 col-sm-12 col-sm-offset-0 d-flex wrapper-custom-addUser-basicDetails-category">
          <ReactMultiSelectCheckboxes
            {...input.value}
            value={selected}
            onChange={(opts) => {
              return input.onChange(opts.map((p) => p.value));
            }}
            placeholderButtonLabel={placeholder}
            getDropdownButtonLabel={(defaultLabel) => {
              var returnData =
                Array.isArray(defaultLabel.value) &&
                defaultLabel.value.length > 0
                  ? `${defaultLabel.value.length} Selected`
                  : placeholder;
              return returnData;
            }}
            options={opts}
            className="react-multi-select-checkboxes-custom-css"
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
          {field.showbutton ? (
            <Button
              className="btn btn-custom-blue ml-10"
              bsStyle=""
              onClick={field.onManageClick}
            >
              {LocaleStrings.button_manage_category}
            </Button>
          ) : (
            ""
          )}
        </div>
        {/* <div className="col-sm-12">
            <Button className="btn btn-custom-blue" bsStyle="" onClick={field.onManageClick}>{LocaleStrings.button_manage_category}</Button>
          </div> */}
      </div>
    );
  }

  render() {
    var { session, source } = this.props;
    var { showPasswordField } = this.state;

    return (
      <div className="basicform">
        <Field
          name="email"
          label={LocaleStrings.user_form_label_email}
          placeholder={LocaleStrings.user_form_label_email}
          type="email"
          component={this.renderFieldText}
          mandatory="true"
          labelposition={LABEL_POSITION_TOP}
        />

        <Field
          name="firstname"
          label={LocaleStrings.user_form_label_firstname}
          placeholder={LocaleStrings.user_form_label_firstname}
          type="text"
          component={this.renderFieldText}
          mandatory="true"
          labelposition={LABEL_POSITION_TOP}
        />
        <Field
          name="lastname"
          label={LocaleStrings.user_form_label_lastname}
          placeholder={LocaleStrings.user_form_label_lastname}
          type="text"
          component={this.renderFieldText}
          mandatory="true"
          labelposition={LABEL_POSITION_TOP}
        />

        <Field
          name="userpassword"
          label={LocaleStrings.user_form_label_password}
          placeholder={LocaleStrings.reviewer_form_label_password_placeholder}
          type="password"
          component={this.renderFieldText}
          labelposition={LABEL_POSITION_TOP}
        />
      </div>
    );
  }
}
